import { downloadExcel, get, patch, post } from '@/api/base'
import identifiersApi from '@/api/containers/identifiers'
import { csvFieldsMap, requiredFields } from '@/api/containers/import'
import { getManualValues } from '@/api/containers/manual_values'
import { getRouteStops } from '@/api/containers/route_stops'
import { getSensorData } from '@/api/containers/sensor_data'
import sensorsApi from '@/api/containers/sensors'
import { selectableTypeVolumes } from '@/api/containers/type_volumes'
import { createUvvCheck, deleteUvvCheck, getUvvChecks } from '@/api/containers/uvv_checks'
import { getVersions } from '@/api/containers/versions'

const containersApi = {
  create: async params => {
    return await post({
      path: `containers`,
      params,
    })
  },
  get: async containerUuid => {
    const response = await get({ path: `containers/${containerUuid}` })
    return response.success ? response.data.container : null
  },
  getAll: async params => {
    const response = await get({
      path: 'containers',
      params,
    })
    return response.success
      ? {
          ...response,
          containers: response.data.containers,
          pagination: response.data.meta.pagination,
        }
      : response
  },
  getDetails: async containerUuid => {
    const response = await get({ path: `containers/${containerUuid}/details` })
    return response.success ? response.data.details : null
  },
  delete: async containerUuid => {
    return await patch({
      path: `containers/${containerUuid}`,
      params: { status: 'deleted' },
    })
  },
  update: async (containerUuid, params) => {
    const response = await patch({
      path: `containers/${containerUuid}`,
      params,
    })
    return response.success ? response.data.container : null
  },
  updateHistoricData: async (containerUuid, sensorUuid) => {
    const response = await post({
      path: `containers/${containerUuid}/fetch_data`,
      params: { sensor_uuid: sensorUuid },
    })
    return response.success ? response.data.container : null
  },
  downloadContainersReport: async (params = {}) => {
    await downloadExcel({
      path: 'containers/exports_excel/containers_report',
      params,
    })
  },
  getGeoJson: async params => {
    const response = await get({
      path: 'containers_geojson',
      params,
    })
    return response.success ? response.data : response
  },
  selectableContainers: async params => {
    const response = await get({
      path: `containers/selectable_containers`,
      params,
    })
    return response.success
      ? {
          ...response,
          containers: response.data.containers,
          pagination: response.data.meta.pagination,
        }
      : response
  },
  csvFieldsMap,
  createUvvCheck,
  deleteUvvCheck,
  getManualValues,
  getRouteStops,
  getSensorData,
  getUvvChecks,
  getVersions,
  requiredFields,
  selectableTypeVolumes,
  identifiers: identifiersApi,
  sensors: sensorsApi,
}

export default containersApi
